/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { accountTerminalApplicationsGet } from "../../funcs/accountTerminalApplicationsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetAccountTerminalApplicationRequest$inboundSchema,
};

export const tool$accountTerminalApplicationsGet: ToolDefinition<typeof args> =
  {
    name: "account-terminal-applications-get",
    description:
      `Verifies if a specific Terminal Application is linked to an Account. This endpoint acts as a validation check for the link's existence.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/terminal-applications.read\` scope.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await accountTerminalApplicationsGet(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value.result;

      return formatResult(value, apiCall);
    },
  };
